import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, TableData } from "components";
import { errorAlert } from "helpers/alerts";
import { getAllPINProductsService, getPINProductsService } from "services/admin/productService";
import { Box, Grid } from "@mui/material";
import { setBagPINProductService } from "services/client/bagService";
import { setPINProducts } from "redux/slices/admin/productSlice";
import { setPINProducts as setBagPINProducts } from "redux/slices/client/bagSlice";
import { setLoading } from "redux/slices/uiSlice";
import { validatePermission } from "helpers/authentication";
import { sortArrayBy } from "helpers/util";

const BagPINProductScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentCommerce } = useSelector((store) => store.commerces);
  const currentBag = currentCommerce.bags.find(bag => bag.type === 'PDS');
  const {
    justProducts,
    currentPINSegment,
    pinProducts: bagPINProducts,
  } = useSelector((store) => store.bags);
  const {
    pinProducts
  } = useSelector((state) => state.products);


  useEffect(() => {
    if (justProducts)
      getAllPINProductsService()
        .then((data) => dispatch(setPINProducts(data)))
        .catch(error => errorAlert(error))
    else
      getPINProductsService(currentPINSegment.id)
        .then((data) => dispatch(setPINProducts(data)))
        .catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerCheck = async (row, state) => {
    dispatch(setLoading(true));
    setBagPINProductService(currentBag.id, row.idSegment.id, row.id, {
      state: !state
    }).then((response) => {
      dispatch(setBagPINProducts(response));
    }).catch(error => errorAlert(error))
      .finally(() => dispatch(setLoading(false)));
  };

  const handlerSetCommission = async (commission, row) => {
    dispatch(setLoading(true));
    setBagPINProductService(currentBag.id, row.idSegment.id, row.id, {
      commission
    }).then((response) => {
      dispatch(setBagPINProducts(response));
    }).catch(error => errorAlert(error))
      .finally(() => dispatch(setLoading(false)));
  }

  return (
    <>
      <Box mt={2} />
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="commerce">Servicios</div>
          {!justProducts && <div className="bag">{currentPINSegment.name} </div>}
        </div>
        <div>
        </div>
      </Grid>
      <TableData
        dataRows={sortArrayBy(pinProducts, a => a.name).map((item) => {
          const service = bagPINProducts?.find(({ idProduct }) => idProduct.id === item.id);
          return {
            ...item,
            service
          };
        })}
        dataTitle={[
          "Logo", 
          "Nombre", 
          validatePermission("comercios", "comisiones", ["ver"]) &&  "Comisión del Canal", 
          "Asignado"
        ].filter(Boolean)}
        formatter={({ fd, name, service }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          validatePermission("comercios", "comisiones", ["ver"]) && { 
            name: "commission", 
            type: "input", 
            value: service?.commission || 0, 
            onBlur: handlerSetCommission 
          },
          { name: "state", type: "boolean", value: service?.state },
        ].filter(Boolean)}
        onChecked={handlerCheck}
      />
    </>
  );
};

export default BagPINProductScreen;
